// removed by extract-text-webpack-plugin
module.exports = {"container":"_170bFmT","mainContent":"SKoJwiD","container__accordion":"seWJYwj","iconBar":"G2lBJZk","greeterWrapper":"HZ254Fm","myAccountLinksWrapper":"_2kRRN8_"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Footer/Footer.css
// module id = ./template/components/Footer/Footer.css
// module chunks = client.sitechrome